/** Weight Loss + Inventory — rutas independientes (normal e insurance). */
const baseMeta = { action: 'index', resource: 'administration' }

function childRoutes(namePrefix, programContext) {
  const meta = { ...baseMeta, programContext }
  return [
    { path: '', redirect: 'reports' },
    {
      path: 'reports',
      name: `${namePrefix}-wl-reports`,
      component: () => import('@/view/pages/weightloss-inventory/reports/WlReportsHub.vue'),
      meta,
    },
    {
      path: 'config/treatments',
      name: `${namePrefix}-wl-treatments`,
      component: () => import('@/view/pages/weightloss-inventory/config/TableWlTreatments.vue'),
      meta,
    },
    {
      path: 'config/prices',
      name: `${namePrefix}-wl-prices`,
      component: () => import('@/view/pages/weightloss-inventory/config/TableWlPrices.vue'),
      meta,
    },
    {
      path: 'config/addons',
      name: `${namePrefix}-wl-addons`,
      component: () => import('@/view/pages/weightloss-inventory/config/TableWlAddons.vue'),
      meta,
    },
    {
      path: 'patients',
      name: `${namePrefix}-wl-patients`,
      component: () => import('@/view/pages/weightloss-inventory/patients/TableWlPatients.vue'),
      meta,
    },
    {
      path: 'appointments',
      name: `${namePrefix}-wl-appointments`,
      component: () =>
        import('@/view/pages/weightloss-inventory/appointments/TableWlAppointments.vue'),
      meta,
    },
    {
      path: 'visits',
      name: `${namePrefix}-wl-visits-list`,
      component: () => import('@/view/pages/weightloss-inventory/visits/TableWlVisits.vue'),
      meta,
    },
    {
      path: 'inventory/categories',
      name: `${namePrefix}-inv-categories`,
      component: () => import('@/view/pages/weightloss-inventory/inventory/TableInvCategories.vue'),
      meta,
    },
    {
      path: 'inventory/distributors',
      name: `${namePrefix}-inv-distributors`,
      component: () => import('@/view/pages/weightloss-inventory/inventory/TableInvDistributors.vue'),
      meta,
    },
    {
      path: 'inventory/items',
      name: `${namePrefix}-inv-items`,
      component: () => import('@/view/pages/weightloss-inventory/inventory/TableInvItems.vue'),
      meta,
    },
    {
      path: 'inventory/movements',
      name: `${namePrefix}-inv-movements`,
      component: () => import('@/view/pages/weightloss-inventory/inventory/TableInvMovements.vue'),
      meta,
    },
    {
      path: 'inventory/stock',
      name: `${namePrefix}-inv-stock`,
      component: () => import('@/view/pages/weightloss-inventory/inventory/TableInvStock.vue'),
      meta,
    },
  ]
}

function createProgramRoute(basePath, programContext) {
  const namePrefix = programContext === 'insurance' ? 'insurance-wl' : 'wl'
  return {
    path: basePath,
    component: () => import('@/view/pages/weightloss-inventory/layout/WeightLossLayout.vue'),
    meta: { ...baseMeta, programContext },
    children: childRoutes(namePrefix, programContext),
  }
}

const legacyRedirects = [
  { path: '/admin/weightloss-inventory', redirect: '/weightloss/reports' },
  { path: '/admin/weightloss-inventory/treatments', redirect: '/weightloss/config/treatments' },
  { path: '/admin/weightloss-inventory/prices', redirect: '/weightloss/config/prices' },
  { path: '/admin/weightloss-inventory/addons', redirect: '/weightloss/config/addons' },
  { path: '/admin/weightloss-inventory/patients', redirect: '/weightloss/patients' },
  { path: '/admin/weightloss-inventory/appointments', redirect: '/weightloss/appointments' },
  { path: '/admin/weightloss-inventory/visits', redirect: '/weightloss/visits' },
  { path: '/admin/weightloss-inventory/reports', redirect: '/weightloss/reports' },
  {
    path: '/admin/weightloss-inventory/inventory/categories',
    redirect: '/weightloss/inventory/categories',
  },
  {
    path: '/admin/weightloss-inventory/inventory/distributors',
    redirect: '/weightloss/inventory/distributors',
  },
  { path: '/admin/weightloss-inventory/inventory/items', redirect: '/weightloss/inventory/items' },
  {
    path: '/admin/weightloss-inventory/inventory/movements',
    redirect: '/weightloss/inventory/movements',
  },
  { path: '/admin/weightloss-inventory/inventory/stock', redirect: '/weightloss/inventory/stock' },
  { path: '/cash-account/weightloss', redirect: '/weightloss/reports' },
  { path: '/cash-account/weightloss/patients', redirect: '/weightloss/patients' },
  { path: '/cash-account/weightloss/visits', redirect: '/weightloss/visits' },
  { path: '/cash-account/weightloss/reports', redirect: '/weightloss/reports' },
  { path: '/cash-account/weightloss/config/treatments', redirect: '/weightloss/config/treatments' },
  { path: '/cash-account/weightloss/config/prices', redirect: '/weightloss/config/prices' },
  { path: '/cash-account/weightloss/config/addons', redirect: '/weightloss/config/addons' },
  {
    path: '/cash-account/weightloss/inventory/categories',
    redirect: '/weightloss/inventory/categories',
  },
  {
    path: '/cash-account/weightloss/inventory/distributors',
    redirect: '/weightloss/inventory/distributors',
  },
  { path: '/cash-account/weightloss/inventory/items', redirect: '/weightloss/inventory/items' },
  {
    path: '/cash-account/weightloss/inventory/movements',
    redirect: '/weightloss/inventory/movements',
  },
  { path: '/cash-account/weightloss/inventory/stock', redirect: '/weightloss/inventory/stock' },
  { path: '/insurance-cash-account/weightloss', redirect: '/insurance-weightloss/reports' },
  { path: '/insurance-cash-account/weightloss/patients', redirect: '/insurance-weightloss/patients' },
  { path: '/insurance-cash-account/weightloss/visits', redirect: '/insurance-weightloss/visits' },
  { path: '/insurance-cash-account/weightloss/reports', redirect: '/insurance-weightloss/reports' },
  {
    path: '/insurance-cash-account/weightloss/config/treatments',
    redirect: '/insurance-weightloss/config/treatments',
  },
  {
    path: '/insurance-cash-account/weightloss/config/prices',
    redirect: '/insurance-weightloss/config/prices',
  },
  {
    path: '/insurance-cash-account/weightloss/config/addons',
    redirect: '/insurance-weightloss/config/addons',
  },
  {
    path: '/insurance-cash-account/weightloss/inventory/categories',
    redirect: '/insurance-weightloss/inventory/categories',
  },
  {
    path: '/insurance-cash-account/weightloss/inventory/distributors',
    redirect: '/insurance-weightloss/inventory/distributors',
  },
  {
    path: '/insurance-cash-account/weightloss/inventory/items',
    redirect: '/insurance-weightloss/inventory/items',
  },
  {
    path: '/insurance-cash-account/weightloss/inventory/movements',
    redirect: '/insurance-weightloss/inventory/movements',
  },
  {
    path: '/insurance-cash-account/weightloss/inventory/stock',
    redirect: '/insurance-weightloss/inventory/stock',
  },
]

export const wlInventoryRoutes = [
  createProgramRoute('/weightloss', 'normal'),
  createProgramRoute('/insurance-weightloss', 'insurance'),
  ...legacyRedirects,
]
